function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 18.5,
  cy: 18.5,
  r: 18.2075,
  stroke: "#023C40",
  strokeWidth: 0.584906
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M28 9C28.552 9 29 9.448 29 10V24C29 24.552 28.552 25 28 25H13.455L9 28.5V10C9 9.448 9.448 9 10 9H28ZM27 11H11V24.385L12.763 23H27V11ZM17.515 13.412L17.962 14.1C16.294 15.003 16.323 16.452 16.323 16.764C16.478 16.744 16.641 16.74 16.803 16.755C17.705 16.839 18.416 17.58 18.416 18.5C18.416 19.466 17.632 20.25 16.666 20.25C16.129 20.25 15.616 20.005 15.292 19.66C14.777 19.114 14.5 18.5 14.5 17.505C14.5 15.755 15.728 14.187 17.515 13.412ZM22.515 13.412L22.962 14.1C21.294 15.003 21.323 16.452 21.323 16.764C21.478 16.744 21.641 16.74 21.803 16.755C22.705 16.839 23.416 17.58 23.416 18.5C23.416 19.466 22.632 20.25 21.666 20.25C21.129 20.25 20.616 20.005 20.292 19.66C19.777 19.114 19.5 18.5 19.5 17.505C19.5 15.755 20.728 14.187 22.515 13.412Z",
  fill: "#023C40"
});

function SvgQuote(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuote);
export default __webpack_public_path__ + "static/media/quote.d50e54e0.svg";
export { ForwardRef as ReactComponent };